import React from "react";

interface ImportSuccessToastProps {
  clientFirstName: string;
  onGoToReassessment: () => void;
}

export const ImportSuccessToast: React.FC<ImportSuccessToastProps> = ({ clientFirstName, onGoToReassessment }) => {
  const clientName = clientFirstName.length ? `${clientFirstName}\u2019s` : "your client\u2019s";
  return (
    <div className="flex flex-col gap-1">
      <p className="text-sm font-semibold text-white ph-no-capture">Successfully updated {clientName} data</p>
      <p className="text-sm text-white">
        Your client data is now refreshed and available to use{" "}
        <button
          onClick={onGoToReassessment}
          className="font-semibold underline bg-transparent border-none p-0 text-sm text-white cursor-pointer"
        >
          Go to Reassessment
        </button>
      </p>
    </div>
  );
};
